import { SUBSCRIPTION_SCREEN_ID } from 'constants/analytics';

import { ActionEventAction, ElementEventAction } from 'services/Analytics/core';

import { changePathNameToScreenId } from '../helpers';

import { trackClick } from './mainTrackers';

export const sendAnalyticResetContactUsClick = () => {
    const screenId = changePathNameToScreenId();

    trackClick({
        screenIdParam: changePathNameToScreenId(),
        elementEvent: ElementEventAction.text,
        actionEvent: ActionEventAction.contactUs,
        isEventSchemaKey: screenId.includes(SUBSCRIPTION_SCREEN_ID),
    });
};
